import { render, staticRenderFns } from "./PersonaViaticoPage.vue?vue&type=template&id=08ee401a"
import script from "./PersonaViaticoPage.js?vue&type=script&lang=js&external"
export * from "./PersonaViaticoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports